import script from "./MobileHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileHeader.vue?vue&type=script&setup=true&lang=js"

import "./MobileHeader.vue?vue&type=style&index=0&id=20c456e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20c456e4"]])

export default __exports__